// DBMS 타입별 브랜드 뱃지 유틸 — 탐색기·연결 목록 등에서 가시성 목적으로 공용 사용
// 렌더 방식: 브랜드 컬러 배지(square) + 흰색 로고(또는 letter) 내부
// - 작은 크기(12~16px)에서도 배경색으로 브랜드가 즉시 식별됨
// - 로고 실루엣(코끼리/돌고래/물개 등)도 흰색 단색이라 깔끔하게 표시

import React from 'react';
import { SiPostgresql, SiMysql, SiMariadb } from 'react-icons/si';
import { DiSqllite } from 'react-icons/di';
import { FaDatabase } from 'react-icons/fa';

// 브랜드별 메타. Icon 이 없는 경우 letter 로 렌더(흰색 텍스트)
// 모두 브랜드 실루엣을 흰색으로 렌더하고 브랜드 컬러 뱃지 위에 배치 → 색상+실루엣 이중 단서로 식별성↑
const DBMS_META = {
    // Oracle 은 **실린더**를 쓴다(사용자 결정 2026-09-12). 공식 마크가 가로로 긴 워드마크
    // ('ORACLE' 글자)라 정사각 배지 12~16px 안에서는 붉은 얼룩으로 뭉갰다 — innerScale 을
    // 키워 봐도 비율이 안 맞는다. 이 파일의 설계는 「브랜드 색 + 흰 실루엣」의 이중 단서인데
    // 워드마크는 실루엣 역할을 못 한다. 빨강은 그대로라 색으로는 여전히 즉시 갈린다.
    oracle:     { Icon: FaDatabase,   color: '#e74c3c', label: 'Oracle',     innerScale: 0.62 },
    postgresql: { Icon: SiPostgresql, color: '#336791', label: 'PostgreSQL' },                  // 코끼리 실루엣
    postgres:   { Icon: SiPostgresql, color: '#336791', label: 'PostgreSQL' },
    sqlite:     { Icon: DiSqllite,    color: '#003B57', label: 'SQLite' },                      // Devicon 의 실루엣이 단순·선명
    tibero:     { Icon: null,         letter: 'T',       color: '#6f42c1', label: 'Tibero' },   // 공식 로고 미제공 → 문자
    mysql:      { Icon: SiMysql,      color: '#00758F', label: 'MySQL' },                       // 돌고래
    mariadb:    { Icon: SiMariadb,    color: '#003545', label: 'MariaDB' },                     // 물개
};

const DEFAULT_META = { Icon: null, letter: '?', color: '#6b7280', label: 'Database' };

export function getDbmsMeta(dbType) {
    const key = String(dbType || '').toLowerCase();
    return DBMS_META[key] || DEFAULT_META;
}

/**
 * <DbmsIcon dbType="oracle" size={16} />
 * - 브랜드 컬러 라운드 사각 뱃지 + 흰색 로고(또는 대표 문자) 내부
 * - size: 뱃지 한 변 픽셀 (기본 16)
 */
export function DbmsIcon({ dbType, size = 16, className, style, title }) {
    const { Icon, letter, color, label, innerScale } = getDbmsMeta(dbType);
    const innerPx = Math.max(8, Math.floor(size * (innerScale || 0.72)));
    const fontPx  = Math.max(9, Math.floor(size * 0.70));
    const badgeStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        minWidth: size,
        borderRadius: Math.max(2, Math.floor(size * 0.18)),
        background: color,
        color: '#fff',
        flexShrink: 0,
        boxShadow: '0 0 0 0.5px rgba(255,255,255,0.08) inset',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontSize: fontPx,
        fontWeight: 700,
        lineHeight: 1,
        ...(style || {})
    };
    return (
        <span className={className} style={badgeStyle} title={title || label} aria-label={label}>
            {Icon ? <Icon size={innerPx} color="#fff" /> : <span>{letter}</span>}
        </span>
    );
}
